export default () => ({
  loading: false,

  scrollToSize() {
    const yOffset = -600;

    const element = document.getElementById("sizes");
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  },

  async checkSizeAlert(form) {
    // Check for bracketing with eComID Size Alert
    const sizeInput = form.querySelector('input[name="size"]');
    const selectedSize = sizeInput ? sizeInput.value : null;

    if (selectedSize && window.ecomidSizeAlert) {
      try {
        const shouldTriggerAlert =
          await window.ecomidSizeAlert.checkAndTriggerAlert(selectedSize);

        if (shouldTriggerAlert) {
          // Size Alert was triggered, don't proceed with add to cart
          console.log("Add to cart prevented - Size Alert triggered");
          return true; // Alert was triggered
        }
      } catch (error) {
        console.error("Error checking Size Alert:", error);
        // Continue with normal add to cart on error
      }
    }

    return false; // No alert triggered, proceed with add to cart
  },

  async addToCart(
    form,
    button,
    productImage,
    productTitle,
    productVariant,
    isExpressCheckout = false,
    showBackInStock
  ) {
    // Check for bracketing with eComID Size Alert
    const alertTriggered = await this.checkSizeAlert(form);
    if (alertTriggered) {
      return; // EcomID Size Alert was triggered, don't proceed with add to cart
    }

    this.loading = true;

    if (!form || !button || button.getAttribute("aria-disabled") === "true") {
      return;
    }
    if (showBackInStock) {
      this.$dispatch("remindme", {
        title: productTitle,
        size: form.querySelector("[name='size']").value,
        id: form.querySelector("[name='id']").value,
      });
      return;
    }
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/javascript`,
      },
    };
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    let formData = new FormData(form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        this.loading = false;

        this.$dispatch("cart-updated");
        this.$dispatch("quickshop-hide");

        if (response.status == 422) {
          this.$dispatch("cart-notice-error", false);
        } else if (!isExpressCheckout) {
          this.$dispatch("cart-notice", {
            image: productImage,
            title: productTitle,
            target: form,
            variant: productVariant,
          });
        }

        if (isExpressCheckout) {
          document.location.href = "/cart/checkout";
        }

        return response.json();
      })
      .then((response) => {
        const variant = Tracking.transformVariant(response);
        if (variant && Tracking) {
          Tracking.addToCart(variant);
        }

        // Update Nosto cart after we have the response
        if (typeof Nosto !== "undefined" && window.Nosto) {
          // Get store data from Alpine for tracking
          const nostoState = Alpine.store("nostoState").data;

          // Get product data from the form
          const productId = form.querySelector("[name='id']").value;
          const quantity = parseInt(
            form.querySelector("[name='quantity']")?.value || 1
          );

          // Track add to cart with attribution data and product details
          if (window.Nosto.trackAddToCart) {
            window.Nosto.trackAddToCart({
              productId: productId,
              quantity: quantity,
              nostoRef: nostoState.attributionKey || "",
              // Add product details for better tracking
              product: {
                id: productId,
                name: productTitle,
                price: productVariant?.price || 0,
                variant: productVariant?.title || "",
                quantity: quantity,
                url: nostoState.productUrl || window.location.href,
              },
            });
          }

          // Track cart update with product details
          if (window.Nosto.trackCartUpdate) {
            window.Nosto.trackCartUpdate({
              items: [
                {
                  productId: productId,
                  quantity: quantity,
                  nostoRef: nostoState.attributionKey || "",
                  product: {
                    id: productId,
                    name: productTitle,
                    price: productVariant?.price || 0,
                    variant: productVariant?.title || "",
                    quantity: quantity,
                    url: nostoState.productUrl || window.location.href,
                  },
                },
              ],
            });
          }

          // Update store with new current URL
          Alpine.store("nostoState").set({
            ...nostoState,
          });

          // Reload cart to update recommendations
          window.Nosto.reloadCartWithFlags({ skipEvents: true });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    return false;
  },

  initForm() {
    const form = this.$refs.addToCartForm;
    form.addEventListener("submit", function (event) {
      event.preventDefault();
    });
  },
});
